/**
 * Phone helpers for the login and user forms (SFAPI-209).
 *
 * The API reads a phone typed without its country code in the restaurant's
 * country. The login screen has no restaurant yet, so there the number must
 * be international (+221…, +224…).
 */

const INTERNATIONAL_PHONE = /^\+[1-9]\d{6,14}$/;

/** Removes spaces and turns a leading "00" into "+". */
export function normalizeLoginIdentifier(value: string): string {
  const compact = value.replace(/\s+/g, "");
  return compact.startsWith("00") ? `+${compact.slice(2)}` : compact;
}

export function isInternationalPhone(value: string): boolean {
  return INTERNATIONAL_PHONE.test(value);
}

export const PHONE_ERRORS: Record<string, string> = {
  "validation.user.error.phone.international_format_required":
    "Saisissez le numéro au format international, avec l'indicatif du pays (ex. +221 77 123 45 67).",
  "validation.user.error.phone.invalid": "Numéro de téléphone invalide.",
};

/** French message for a phone violation in an API error `detail`, if any. */
export function phoneErrorMessage(detail: string | undefined): string | undefined {
  if (!detail) {
    return undefined;
  }
  const key = Object.keys(PHONE_ERRORS).find((k) => detail.includes(k));
  return key ? PHONE_ERRORS[key] : undefined;
}
